<template>
  <DragDialog
    title="导出"
    :width="700"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="project-name-box">
      <div class="common-form-box">
        <el-form
          :model="form"
          class="public-form-primary"
          :rules="rules"
          label-width="102px"
          ref="form">
          <el-form-item
            label="项目名称:"
            prop="projId">
            <div class="form-item-box">
              <div class="common-select-box">
                <el-select
                  class="primary-select"
                  size="small"
                  filterable
                  placeholder="请选择项目"
                  v-model="form.projId"
                  :popper-append-to-body="false"
                  @change="handleProjChange">
                  <template slot="prefix">
                    <i
                      slot="suffix"
                      class="el-input__icon el-icon-search"></i>
                  </template>
                  <el-option
                    v-for="(item, index) in projList"
                    :key="index"
                    :label="item.projectName"
                    :value="item.projectId" />
                </el-select>
              </div>
              <div
                class="common-switch-box"
                v-if="form.projId">
                <el-switch
                  class="switch-primary"
                  v-model="isExportProj"
                  active-text="一键导出" />
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      v-if="isExportProj"
      class="export-proj-box">
      <div class="info-item-box">
        <div class="label-box validate">
          <span class="dialog-label">数据集资源类型</span>
          <el-tooltip
          :effect="$theme.tooltipKey()"
            placement="top-start"
            popper-class="common-panel-tooltip-box">
            <div slot="content">
              <div>
                若这些数据集需要发布到Linux环境，则需以minIO资源的形式导出；
              </div>
            </div>
            <div class="icon-box">
              <icon-svg icon-class="ic-jieshishuoming" />
            </div>
          </el-tooltip>
        </div>
        <div class="radio-box">
          <div class="common-radio-box radio-primary">
            <el-radio
              v-model="resType"
              :label="0"
              >windows资源</el-radio
            >
          </div>
          <div class="common-radio-box radio-primary">
            <el-radio
              v-model="resType"
              :label="1"
              >minIO资源</el-radio
            >
          </div>
        </div>
      </div>
      <div class="info-item-box">
        <div class="label-box last">
          <span class="dialog-label">场景导出选项</span>
          <el-tooltip
          :effect="$theme.tooltipKey()"
            placement="top-start"
            popper-class="common-panel-tooltip-box">
            <div slot="content">
              该设置仅对包含有构件库模型的场景有效：
              系统默认“不导出构件库模型的源文件”；
              若发布到的平台具备模型转换能力，且需要
              对该场景进行二次编辑，则需要“导出构件库 模型的源文件”
            </div>
            <div class="icon-box">
              <icon-svg icon-class="ic-jieshishuoming" />
            </div>
          </el-tooltip>
        </div>
        <div class="common-switch-box">
          <el-switch
            class="switch-primary"
            v-model="isExportElemSource"
            active-text="导出场景内构件库模型的源文件" />
        </div>
      </div>
      <div class="export-illustrate-box">
        <p>【注】一键导出的数据包括：</p>
        <p>（1）项目基本信息</p>
        <p class="text-indent">
          项目名称、项目地点、项目概述、缩略图、创建时间、更新时间等
        </p>
        <p>（2）数据集</p>
        <p class="text-indent">
          已转换完成的模型/模型组（若包含纹理动画，仅导出已应用的纹理动画）
        </p>
        <p class="text-indent">所有倾斜摄影、遥感影象和二维图纸</p>
        <p class="text-indent">已转换过的360、点云、WMTS</p>
        <p>（3）所有已发布的场景</p>
      </div>
      <div class="common-button-box">
        <el-button
          class="primary-btn primary-ang-btn"
          type="primary"
          size="small"
          @click="exportAllData"
          >导出所有数据</el-button
        >
      </div>
    </div>
    <div
      v-else
      class="export-content-box">
      <div class="export-type-box">
        <div
          :class="`type-item-box ${
            exportType === 'fileManage' ? 'active-item' : ''
          }`"
          @click="switchExportType('fileManage')">
          数据集
        </div>
        <div
          :class="`type-item-box ${
            exportType === 'sceneManage' ? 'active-item' : ''
          }`"
          @click="switchExportType('sceneManage')">
          场景
        </div>
        <div
          :class="`type-item-box ${
            exportType === 'projInfo' ? 'active-item' : ''
          }`"
          @click="switchExportType('projInfo')">
          项目信息
        </div>
      </div>
      <div class="split-line"></div>
      <div
        class="export-type-content-box"
        v-if="form.projId">
        <div v-if="loading">
          <Spin
            :pointNum="8"
            :translateX="25"
            background="var(--base-primary-bgColor)" />
        </div>
        <div
          v-else
          class="data-box">
          <div
            class="file-manage-box"
            v-show="exportType === 'fileManage'">
            <div
              v-if="dataSetTreeData.length"
              class="dataset-content-box">
              <div class="export-resource-box">
                <div class="label-box validate">
                  <span class="dialog-label">数据集资源类型</span>
                  <el-tooltip
                  :effect="$theme.tooltipKey()"
                    placement="top-start"
                    popper-class="common-panel-tooltip-box">
                    <div slot="content">
                      <div>
                        若这些数据集需要发布到Linux环境，则需以minIO资源的形式导出；
                      </div>
                    </div>
                    <div class="icon-box">
                      <icon-svg icon-class="ic-jieshishuoming" />
                    </div>
                  </el-tooltip>
                </div>
                <div class="radio-box">
                  <div class="common-radio-box radio-primary">
                    <el-radio
                      v-model="exportResType"
                      :label="0"
                      >windows资源</el-radio
                    >
                  </div>
                  <div class="common-radio-box radio-primary">
                    <el-radio
                      v-model="exportResType"
                      :label="1"
                      >minIO资源</el-radio
                    >
                  </div>
                </div>
              </div>
              <div class="common-tree-box">
                <el-tree
                  class="dialog-tree-small-primary"
                  ref="dataSetTree"
                  :data="dataSetTreeData"
                  :props="defaultProps"
                  node-key="nodeId"
                  highlight-current
                  show-checkbox
                  default-expand-all
                  :expand-on-click-node="false">
                  <div
                    slot-scope="{ node, data }"
                    class="custom-node-box">
                    <div>
                      <icon-svg
                        v-if="data.nodeType === 1"
                        class="icon"
                        icon-class="ic-ico_folder" />
                      <icon-svg
                        v-if="data.nodeType === 2"
                        class="icon"
                        icon-class="ic-ico-group" />
                    </div>
                    <span
                      class="node-lable text-overflow"
                      :title="node.label"
                      >{{ node.label }}</span
                    >
                  </div>
                </el-tree>
              </div>
              <div class="description-box">
                <span>【注】以上列表中只显示</span>
                <el-tooltip
                :effect="$theme.tooltipKey()"
                  placement="top-start"
                  popper-class="common-panel-tooltip-box">
                  <div slot="content">
                    <div class="public-tips-primary">
                      (1)已转换完成的模型/模型组（若包含纹理动画，仅导出已应用的纹理动画）
                    </div>
                    <div class="public-tips-primary">
                      (2)所有倾斜摄影、遥感影像和二维图纸
                    </div>
                    <div class="public-tips-primary">
                      (3)已转换过的360、点云、WMTS
                    </div>
                  </div>
                  <div class="tooltip-content-box">已转换完成</div>
                </el-tooltip>
                <span class="public-tips-primary">的数据集</span>
              </div>
              <div class="common-button-box">
                <el-button
                  class="primary-btn primary-ang-btn"
                  type="primary"
                  size="small"
                  @click="exportDataSet"
                  >导出数据集</el-button
                >
              </div>
            </div>
            <div
              v-else
              class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <div class="description-box">当前项目下没有可导出的数据集</div>
              </bj-empty>
            </div>
          </div>
          <div
            class="scene-manage-box"
            v-show="exportType === 'sceneManage'">
            <div
              v-if="sceneList.length"
              class="scene-content-box">
              <div class="export-config-box">
                <div class="item-box">
                  <div class="label-box validate">
                    <span class="dialog-label">构件库模型资源类型</span>
                    <el-tooltip
                    :effect="$theme.tooltipKey()"
                      placement="top-start"
                      popper-class="common-panel-tooltip-box">
                      <div slot="content">
                        <div>该设置仅对包含有构件库模型的场景有效</div>
                      </div>
                      <div class="icon-box">
                        <icon-svg icon-class="ic-jieshishuoming" />
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="radio-box">
                    <div class="common-radio-box radio-primary">
                      <el-radio
                        v-model="exportSceneResType"
                        :label="0"
                        >windows资源</el-radio
                      >
                    </div>
                    <div class="common-radio-box radio-primary">
                      <el-radio
                        v-model="exportSceneResType"
                        :label="1"
                        >minIO资源</el-radio
                      >
                    </div>
                  </div>
                </div>
                <div class="item-box">
                  <div class="label-box last">
                    <span class="dialog-label">场景导出选项</span>
                    <el-tooltip
                    :effect="$theme.tooltipKey()"
                      placement="top-start"
                      popper-class="common-panel-tooltip-box">
                      <div slot="content">
                        该设置仅对包含有构件库模型的场景有效：
                        系统默认“不导出构件库模型的源文件”；
                        若发布到的平台具备模型转换能力，且需要
                        对该场景进行二次编辑，则需要“导出构件库 模型的源文件”
                      </div>
                      <div class="icon-box">
                        <icon-svg icon-class="ic-jieshishuoming" />
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="common-switch-box">
                    <el-switch
                      class="switch-primary"
                      v-model="isSceneExportElemSource"
                      active-text="导出场景内构件库模型的源文件" />
                  </div>
                </div>
              </div>
              <div class="scene-data-box">
                <div class="common-checkbox-box">
                  <el-checkbox
                    class="checkbox-primary"
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                    >全选</el-checkbox
                  >
                </div>
                <div class="checkbox-group-box">
                  <el-checkbox-group
                    class="checkbox-primary"
                    v-model="checkedScenes"
                    @change="handleCheckedSceneChange">
                    <div
                      v-for="(scene, index) in sceneList"
                      :key="index"
                      class="common-checkbox-box">
                      <el-checkbox :label="scene.sceneId">
                        <div
                          class="label"
                          :title="scene.sceneName">
                          <div class="text-overflow">{{ scene.sceneName }}</div>
                        </div>
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
              <div class="export-config-box">
                <div class="description-box public-tips-primary">
                  【注】以上列表中只显示已发布的场景，未发布的场景已被过滤
                </div>
                <div class="common-button-box">
                  <el-button
                    class="primary-btn primary-ang-btn"
                    type="primary"
                    size="small"
                    @click="exportScene"
                    >导出场景</el-button
                  >
                </div>
              </div>
            </div>
            <div
              v-else
              class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <div class="description-box">当前项目下没有可导出的场景</div>
              </bj-empty>
            </div>
          </div>
          <div
            class="proj-info-box"
            v-show="exportType === 'projInfo'">
            <div class="proj-export-content-box">
              <p class="public-tips-primary">
                【注】若目标平台还未创建过该项目，则可将项目信息导出
              </p>
              <p class="text-indent public-tips-primary">
                导出的信息包括以下内容：
              </p>
              <p class="public-tips-primary">（1）项目基本信息</p>
              <p class="text-indent public-tips-primary">
                项目名称、项目地点、项目概述、缩略图、创建时间、 更新时间等
              </p>
              <p class="public-tips-primary">（2）根目录结构</p>
              <p class="text-indent public-tips-primary">
                即文件管理模块的固定结构
              </p>
            </div>
            <div class="common-button-box">
              <el-button
                class="primary-btn"
                type="primary"
                size="small"
                @click="exportProjInfo"
                >导出项目信息</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="common-empty-box"
        v-else>
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <div class="description-box">请先选择项目</div>
        </bj-empty>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import Spin from '@/components/Spin.vue'
import DragDialog from '@/components/CustomDragDialog.vue'

import { Store } from '@/utils/store'
import {
  exportProjCheckService,
  exportProjService,
  exportProjectService,
  exportDatasetService,
  exportDatasetCheckService,
  exportSceneService,
  exportSceneCheckService,
  getExportOptionalProjListService,
  getSceneListService,
  getBimTreeService,
  getRsTreeService,
  getWmtsTreeService,
  getOsgbTreeService,
  getPanoramaTreeService,
  getPointCloudTreeService,
  getCadTreeService,
  getVectorTreeService
} from '@/service/interface'
export default {
  data() {
    return {
      form: {
        projId: ''
      },
      projList: [],
      isExportProj: false, // 是否一键批量导出项目所有数据
      resType: undefined, // 一键导出项目资源资源包类型
      isExportElemSource: false, // 是否导出场景内构件源文件

      loading: true,
      exportType: '',
      isExportRes: false, // 是否导出资源包
      exportResType: undefined, // 导出资源包类型
      dataSetTreeData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },

      sceneList: [],
      isIndeterminate: false,
      checkAll: false,
      checkedScenes: [],
      exportSceneResType: undefined, // 构件库导出资源包类型
      isSceneExportElemSource: false, // 是否导出场景内构件源文件

      rules: {
        projId: [
          {
            required: true,
            message: '请选择项目名称',
            trigger: 'blur'
          }
        ],
        resType: [
          {
            required: true,
            message: '请选择资源类型',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    closeDialog: Function
  },
  components: {
    DragDialog,
    Spin
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.getProjList()
      }
    }
  },
  methods: {
    handleProjChange(projId) {
      this.loading = true
      if (!this.exportType || this.exportType === 'fileManage') {
        if (!this.exportType) this.exportType = 'fileManage'
        this.getDataSetTreeData(projId).then(response => {
          let dataSetTreeData = [
            {
              nodeId: 'all',
              nodeName: '全部',
              nodeType: {
                value: 0,
                displayName: '根节点'
              },
              subNodes: response
            }
          ]
          this.dataSetTreeData = dataSetTreeData

          this.loading = false
        })
        return
      }
      if (this.exportType === 'sceneManage') {
        this.getSceneList(this.form.projId).then(() => {
          this.loading = false
        })
      }
    },
    switchExportType(exportType) {
      if (!this.form.projId) {
        this.$message.warning('请先选择项目')
        return
      }
      if (exportType === this.exportType) return

      this.exportType = exportType

      if (exportType === 'fileManage') {
        this.loading = true
        this.getDataSetTreeData(this.form.projId).then(response => {
          let dataSetTreeData = [
            {
              nodeId: 'all',
              nodeName: '全部',
              nodeType: {
                value: 0,
                displayName: '根节点'
              },
              subNodes: response
            }
          ]
          this.dataSetTreeData = dataSetTreeData

          this.loading = false
        })
      }

      if (exportType === 'sceneManage') {
        this.loading = true
        this.getSceneList(this.form.projId).then(() => {
          this.loading = false
        })
      }
    },
    exportAllData() {
      if (this.resType === undefined) {
        this.$message.warning('请选择导出资源类型')
        return
      }

      let projId = this.form.projId
      let params = {
        projId,
        resType: this.resType,
        exportComponentsSourceFile: this.isExportElemSource
      }
      this.exportProjCheck(projId).then(bool => {
        if (bool) {
          exportProjService(params).then(response => {
            if (response.isSuccess) {
              this.$eventManage.fire('updateExportlist')
              this.cancel()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          this.cancel()
        }
      })
    },
    exportProjCheck(projId) {
      return new Promise(resolve => {
        exportProjCheckService({ projId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let { dataSetList, sceneList } = data

            let validDataSets = []
            let invalidDataSets = []
            if (dataSetList) {
              validDataSets = dataSetList.effectiveItems
              invalidDataSets = dataSetList.unEffectiveItems
            }

            let validScenes = []
            let invalidScenes = []
            if (sceneList) {
              validScenes = sceneList.effectiveItems
              invalidScenes = sceneList.unEffectiveItems
            }

            let checkResult = {
              invalidDataSetsTotal: invalidDataSets.length,
              invalidScenesTotal: invalidScenes.length
            }
            let invalidTotal = invalidDataSets.length + invalidScenes.length
            let validTotal = validDataSets.length + validScenes.length
            if (invalidTotal === validTotal) {
              checkResult.isAllInvalid = true
            } else {
              checkResult.isAllInvalid = false
            }

            if (invalidTotal === 0) {
              resolve(true)
              return
            }

            if (checkResult.isAllInvalid) {
              this.$confirm('所选数据正在导出或发布，请稍后再操作', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false
              }).then(() => {
                resolve(false)
              })
            } else {
              let dataSetMsg = checkResult.invalidDataSetsTotal
                ? `${checkResult.invalidDataSetsTotal}个数据集`
                : ''
              let sceneMsg = checkResult.invalidScenesTotal
                ? `${checkResult.invalidScenesTotal}个场景，`
                : ''

              let message = ''
              if (dataSetMsg && sceneMsg) {
                message = `${dataSetMsg},${sceneMsg}正在导出或发布，是否跳过继续导出`
              } else if (dataSetMsg) {
                message = `${dataSetMsg}正在导出或发布，是否跳过继续导出`
              } else if (sceneMsg) {
                message = `${sceneMsg}正在导出或发布，是否跳过继续导出`
              }

              this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  resolve(true)
                })
                .catch(() => {
                  this.$message.info('取消导出')
                  resolve(false)
                })
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    exportDataSet() {
      let checkedNodes = this.$refs.dataSetTree.getCheckedNodes()
      let dataSets = checkedNodes.filter(el => el.nodeType === 2)
      if (!dataSets.length) {
        this.$message.warning('请选择需要导出的数据集')
        return
      }

      if (this.exportResType === undefined) {
        this.$message.warning('请选择导出资源类型')
        return
      }

      this.exportDataSetCheck(dataSets).then(validDataSets => {
        if (validDataSets.length) {
          let projId = this.form.projId
          let params = this.getExportDatasetParams(projId, validDataSets)
          exportDatasetService(params).then(response => {
            if (response.isSuccess) {
              this.$eventManage.fire('updateExportlist')
              this.cancel()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      })
    },
    exportDataSetCheck(dataSets) {
      return new Promise(resolve => {
        let items = []
        dataSets.forEach(item => {
          let find = items.find(el => el.scheme === item.scheme)
          if (find) {
            find.dataSetIds.push(item.nodeId)
          } else {
            let obj = {
              scheme: item.scheme,
              dataSetIds: [item.nodeId]
            }
            items.push(obj)
          }
        })
        let checkParams = { items }
        exportDatasetCheckService(checkParams).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let unEffectiveItems = data.unEffectiveItems
            if (!unEffectiveItems.length) {
              resolve(dataSets)
              return
            }

            let invalidFiles = []
            unEffectiveItems.forEach(item => {
              let items = item.items
              let files = items.map(el => {
                let obj = {
                  id: el.id,
                  name: el.name
                }
                return obj
              })
              invalidFiles = [...invalidFiles, ...files]
            })

            if (invalidFiles.length === dataSets.length) {
              this.$confirm('当前数据集正在导出或发布，请稍后再操作', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false
              }).then(() => {
                resolve([])
                return
              })
            } else {
              let warningMsg = `${invalidFiles.length}个数据集正在导出或发布，是否跳过继续导出"`
              this.$confirm(warningMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  dataSets = dataSets.filter(item => {
                    let find = invalidFiles.find(el => el.id === item.nodeId)
                    if (find) {
                      return false
                    } else {
                      return true
                    }
                  })
                  resolve(dataSets)
                })
                .catch(() => {
                  this.$message.info('取消导出')
                  resolve([])
                })
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getExportDatasetParams(projId, dataSets) {
      let items = []

      dataSets.forEach(item => {
        let find = items.find(el => el.scheme === item.scheme)
        if (find) {
          find.dataSetIds.push(item.nodeId)
        } else {
          let obj = {
            scheme: item.scheme,
            dataSetIds: [item.nodeId]
          }
          items.push(obj)
        }
      })

      let params = {
        projId,
        resType: this.exportResType,
        items
      }
      return params
    },
    exportScene() {
      if (!this.checkedScenes.length) {
        this.$message.warning('请选择需要导出的场景')
        return
      }

      if (this.exportSceneResType === undefined) {
        this.$message.warning('请选择导出资源类型')
        return
      }

      this.exportSceneCheck(this.checkedScenes).then(validScenes => {
        let projId = this.form.projId

        let params = {
          projId,
          resType: this.exportSceneResType,
          exportComponentsSourceFile: this.isSceneExportElemSource,
          sceneIds: validScenes
        }
        exportSceneService(params).then(response => {
          if (response.isSuccess) {
            this.$eventManage.fire('updateExportlist')
            this.cancel()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    exportSceneCheck(checkedScenes) {
      return new Promise(resolve => {
        let checkParams = { sceneIds: checkedScenes }
        exportSceneCheckService(checkParams).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let unEffectiveItems = data.unEffectiveItems
            if (!unEffectiveItems.length) {
              resolve(checkedScenes)
              return
            }

            let invalidScenes = []
            unEffectiveItems.forEach(item => {
              let items = item.items
              let scenes = items.map(el => {
                let obj = {
                  id: el.id,
                  name: el.name
                }
                return obj
              })
              invalidScenes = [...invalidScenes, ...scenes]
            })

            if (checkedScenes.length === invalidScenes.length) {
              let message = '当前场景正在导出或发布，请稍后再操作'
              this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                showCancelButton: false
              }).then(() => {
                resolve([])
                return
              })
              return
            } else {
              let warningMsg = `${invalidScenes.length}个场景正在导出或发布，是否跳过继续导出"`
              this.$confirm(warningMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  checkedScenes = checkedScenes.filter(item => {
                    let find = invalidScenes.find(el => el.id === item)
                    if (find) {
                      return false
                    } else {
                      return true
                    }
                  })
                  resolve(checkedScenes)
                })
                .catch(() => {
                  this.$message.info('取消导出')
                  resolve([])
                })
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    exportProjInfo() {
      let projId = this.form.projId
      let params = { projectIds: [projId] }
      exportProjectService(params).then(response => {
        if (response.isSuccess) {
          this.$eventManage.fire('updateExportlist')
          this.cancel()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    clearData() {
      this.form = {
        projId: ''
      }
      this.isExportProj = false
      this.resType = undefined
      this.isExportElemSource = false

      this.exportType = ''
      this.isExportRes = false
      this.exportResType = undefined
      this.dataSetTreeData = []

      this.sceneList = []
      this.isIndeterminate = false
      this.checkAll = false
      this.checkedScenes = []
      this.exportSceneResType = undefined
      this.isSceneExportElemSource = false
    },
    getExceptionMsg(files, messageTail) {
      let message = ''
      // 超过两个文件只展示前两个
      if (files.length > 2) {
        let fileNames = `${files[0]}、${files[1]}等${files.length}个文件`
        message = `${fileNames}${messageTail}`
      } else {
        message = `${files}${messageTail}`
      }
      return message
    },
    getDataSetTreeData(projId) {
      return new Promise(resolve => {
        let promiseArray = []
        if (this.isChecked('Data.Migration.Export.Select.Bim')) {
          promiseArray.push(this.getBimTreeData(projId))
        }
        if (this.isChecked('Data.Migration.Export.Select.Rs')) {
          promiseArray.push(this.getRsTreeData(projId))
        }
        if (this.isChecked('Data.Migration.Export.Select.Wmts')) {
          promiseArray.push(this.getWmtsTreeData(projId))
        }
        if (this.isChecked('Data.Migration.Export.Select.Osgb')) {
          promiseArray.push(this.getOsgbTreeData(projId))
        }
        if (this.isChecked('Data.Migration.Export.Select.Panorama')) {
          promiseArray.push(this.getPanoramaTreeData(projId))
        }
        if (this.isChecked('Data.Migration.Export.Select.PountCloud')) {
          promiseArray.push(this.getPointCloudTreeData(projId))
        }
        if (this.isChecked('Data.Migration.Export.Select.Cad')) {
          promiseArray.push(this.getCadTreeData(projId))
        }
        if (this.isChecked('Data.Migration.Export.Select.Vector')) {
          promiseArray.push(this.getVectorTreeData(projId))
        }

        Promise.all(promiseArray).then(response => {
          resolve(response)
        })
      })
    },
    getSceneList(projId) {
      return new Promise(resolve => {
        let params = {
          projId,
          resultCount: 1000,
          skipCount: 0
        }
        getSceneListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let sceneList = data.items.filter(el => this.isPublish(el))
            this.sceneList = sceneList
            resolve()
          }
        })
      })
    },
    isPublish(sceneData) {
      let latestConvertStatus = sceneData.latestConvertStatus
      let status = sceneData.status

      if (latestConvertStatus === 5 && status === 1) {
        return true
      } else {
        return false
      }
    },
    handleCheckAllChange(checked) {
      let checkedScenes = []
      if (checked) {
        checkedScenes = this.sceneList.map(el => el.sceneId)
      }
      this.checkedScenes = checkedScenes
      this.isIndeterminate = false
    },
    handleCheckedSceneChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.sceneList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.sceneList.length
    },
    cancel() {
      this.clearData()
      this.closeDialog()
    },
    getProjList() {
      getExportOptionalProjListService({}).then(response => {
        if (response.isSuccess) {
          let projList = response.data
          this.projList = projList
        }
      })
    },
    getBimTreeData(projId) {
      return new Promise(resolve => {
        getBimTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = 'BIM模型'
            result = this.formatData([result], 'Bim')
            resolve(result[0])
          }
        })
      })
    },
    getRsTreeData(projId) {
      return new Promise(resolve => {
        getRsTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = '遥感影像'
            result = this.formatData([result], 'Rs')
            resolve(result[0])
          }
        })
      })
    },
    getWmtsTreeData(projId) {
      return new Promise(resolve => {
        getWmtsTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = 'WMTS地图服务'
            result = this.formatData([result], 'Wmts')
            resolve(result[0])
          }
        })
      })
    },
    getOsgbTreeData(projId) {
      return new Promise(resolve => {
        getOsgbTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = '倾斜摄影'
            result = this.formatData([result], 'Osgb')
            resolve(result[0])
          }
        })
      })
    },
    getPanoramaTreeData(projId) {
      return new Promise(resolve => {
        getPanoramaTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = '360全景'
            result = this.formatData([result], 'Panorama')
            resolve(result[0])
          }
        })
      })
    },
    getPointCloudTreeData(projId) {
      return new Promise(resolve => {
        getPointCloudTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = '点云'
            result = this.formatData([result], 'PointCloud')
            resolve(result[0])
          }
        })
      })
    },
    getCadTreeData(projId) {
      return new Promise(resolve => {
        getCadTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = '二维图纸'
            result = this.formatData([result], 'Cad')
            resolve(result[0])
          }
        })
      })
    },
    getVectorTreeData(projId) {
      return new Promise(resolve => {
        getVectorTreeService({
          projId,
          onlyFolderNodes: false,
          status: [5]
        }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            result.nodeName = '矢量数据'
            result = this.formatData([result], 'Vector')
            resolve(result[0])
          }
        })
      })
    },
    formatData(treeData, scheme) {
      for (let node of treeData) {
        node['scheme'] = scheme
        if (node.subNodes && node.subNodes.length) {
          this.formatData(node.subNodes, scheme)
        }
      }
      return treeData
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.project-name-box {
  text-align: left;
  border-bottom: 1px solid var(--tabs-card-header-border-color);
  margin: 0 -16px;
  padding: 0 16px;

  .common-form-box {
    margin-left: 32px;

    .form-item-box{
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .common-select-box{
        width: 320px;
        margin-right: 32px;
        :deep(.el-select){
          width: 100%;
          .el-input__inner{
            width: 100%;
          }
        }
      }
    }
  }

  .public-form-primary {
    :deep(.el-form-item__label) {
      text-align: left;
    }
  }

  // /deep/ .el-form-item__label {
  //   text-align: center;
  // }

  // .form-item-box {
  //   display: flex;

  //   .common-select-box {
  //     width: 72%;
  //     .el-select {
  //       width: 100%;
  //     }
  //   }

  //   .common-switch-box {
  //     margin-left: 20px;
  //   }
  // }
}

.export-content-box {
  display: flex;
  height: 500px;
  font-size: 14px;
  color: var(--default-color);

  .export-type-box {
    min-width: 114px;
    padding-top: 8px;
    padding-right: 16px;
    padding-left: 0px;
    font-size: 14px;

    .type-item-box {
      margin: 10px 0px;
      padding: 8px 30px;
      text-align: center;
      background: var(--migration-dataExport-tab-item-bgColor);
      font-weight: 400;
      color: var(--migration-dataExport-tab-item-text-color);
      cursor: pointer;
      border-radius: 6px;

      &:hover {
        background-color: var(--migration-dataExport-tab-item-hover-bgColor);
        border-radius: 6px;
      }

      &:first-child {
        margin-top: 0px;
      }
    }

    .active-item {
      color: var(--base-primary-bgColor);
      background-color: var(--base-bg-light-color24);

      &:hover{
      background-color: var(--base-bg-light-color24);
      }
    }
  }

  .split-line {
    width: 1px;
    height: calc(100% + 16px);
    background: var(--tabs-card-header-border-color);
  }

  .export-type-content-box {
    position: relative;
    flex-grow: 1;
    padding: 10px 20px;

    .data-box {
      height: 100%;
      .file-manage-box {
        height: 100%;
        .dataset-content-box {
          display: flex;
          flex-direction: column;
          height: 100%;
          .common-tree-box {
            flex-grow: 1;
            overflow-y: auto;

            .custom-node-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 14px;

              .node-lable {
                display: inline-block;
                width: 270px;
                text-align: left;
                vertical-align: text-bottom;
              }

              .icon {
                color: var(--icon-color);
                font-size: 16px;
                margin-right: 10px;
                vertical-align: middle;
              }
            }

            /deep/ .el-loading-mask {
              background-color: transparent;
            }
          }

          .export-resource-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 5px 0px;

            .label-box {
              display: flex;
              .icon-box {
                display: flex;
                align-items: center;
                margin-left: 4px;
                &:after {
                  content: '\ff1a';
                  margin-left: 4px;
                  margin-bottom: 2px;
                }
              }
            }

            .validate {
              display: flex;
              align-items: center;
              &:before {
                content: '*';
                color: var(--error-status-color);
                margin-right: 4px;
              }
            }

            .radio-box {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              .common-radio-box {
                &:last-child {
                  margin-left: 16px;
                }
              }
            }
          }

          .description-box {
            display: flex;
            margin-top: 10px;
            margin-left: -5px;
            text-align: left;
            color: var(--base-border-dark-color12);
            font-size: 13px;

            .icon-box {
              margin-left: 5px;
              font-size: 13px;
              color: var(--base-border-dark-color12);
              display: flex;
              align-items: center;
            }

            .tooltip-content-box {
              color: var(--base-light-color26);
            }

            .public-tips-primary{
              margin-top: 2px;
            }
          }

          .common-button-box {
            margin-top: 10px;
            text-align: right;
            // .el-button {
            //   margin-right: 0px;
            // }
          }
        }
      }
      .scene-manage-box {
        height: 100%;

        .scene-content-box {
          display: flex;
          flex-direction: column;
          height: 100%;
          .scene-data-box {
            flex-grow: 1;
            overflow-y: auto;
            font-size: 14px;
            .common-checkbox-box {
              margin-top: 8px;
              .el-checkbox {
                color: var(--default-color);
              }
            }

            .checkbox-group-box {
              margin-left: 25px;

              .label {
                display: flex;
                max-width: 400px;
              }
            }
          }

          .export-config-box {
            .item-box {
              display: flex;
              margin-top: 10px;

              .label-box {
                display: flex;
                .icon-box {
                  margin-left: 4px;
                  display: flex;
                  align-items: center;

                  &:after {
                    content: '\ff1a';
                    margin-left: 4px;
                    margin-bottom: 2px;
                  }
                }
              }

              .validate {
                display: flex;
                align-items: center;
                &:before {
                  content: '*';
                  color: var(--error-status-color);
                  margin-right: 4px;
                }
              }

              .last {
                margin-left: 52px;
              }

              .radio-box {
                flex-grow: 1;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .radio-primary:first-child {
                  margin-right: 16px;
                }
              }
            }

            .description-box {
              margin-top: 5px;
              margin-left: -5px;
              text-align: left;
              color: var(--base-border-dark-color12);
              font-size: 13px;
            }

            .common-button-box {
              text-align: right;
              .el-button {
                margin-right: 0px;
              }
            }
          }
        }
      }
      .proj-info-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        color: var(--base-dark6-color);
        font-size: 13px;
        letter-spacing: 2px;
        text-align: left;
        line-height: 24px;

        .text-indent {
          margin-left: 3em;
        }

        .common-button-box {
          text-align: right;
          .el-button {
            margin-right: 0px;
          }
        }
      }
    }
  }

  .common-empty-box {

    .description-box {
      color: var(--base-border-dark-color12);
    }
  }
}

.export-proj-box {
  margin-top: 15px;
  .info-item-box {
    display: flex;
    margin-top: 10px;

    .label-box {
      display: flex;
      align-items: center;
      color: var(--default-color);
      .icon-box {
        margin-left: 4px;
        display: flex;
        align-items: center;
        &:after {
          content: '\ff1a';
          margin-left: 4px;
          margin-bottom: 2px;
        }
      }
    }

    .validate {
      display: flex;
      align-items: center;
      &:before {
        content: '*';
        color: var(--error-status-color);
        margin-right: 4px;
      }
    }

    .last {
      margin-left: 12px;
    }

    .radio-box {
      flex-grow: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .radio-primary:first-child {
        margin-right: 16px;
      }
    }
  }
  .export-illustrate-box {
    margin-top: 16px;
    margin-left: 8px;
    color: var(--base-dark6-color);
    font-size: 13px;
    letter-spacing: 2px;
    text-align: left;
    line-height: 24px;

    .text-indent {
      margin-left: 3em;
    }
  }
  .common-button-box {
    text-align: right;
  }
}
</style>
